import React from 'react'
import "./CardHeading.scss"

const CardHeading = ({ title }) => {
  return ( 
    <>
      <div className='cardHeading'>
        <h2>{title}</h2>
      </div>
    </>
  ) 
}  

export default CardHeading
